import React from 'react';
import classNames from 'classnames';
import {bem} from '../../utils/bem';

const block = bem('downgrid');

const GridCell = ({children = null, modifiers = {}, className = null, ...rest}) => (
	<td className={classNames(className, block('cell', modifiers))} {...rest}>
		{children}
	</td>
);
export default GridCell;

